import React from "react";
import CardTemplate from "./CardTemplate";
import styled from "styled-components";
import { HomepageData } from "hooks/ConsultantDashboard/useConsultantDashboardData";

interface Props {
	homepageData: HomepageData;
	afterOneYear: boolean;
	visits: number;
}

const Homepage = ({ homepageData, afterOneYear, visits }: Props) => {
	return (
		<CardTemplate title={"Homepage"}>
			<Container>
				<LeftContainer>
					<StyledText>Homepage visitors</StyledText>
					<LargeText>{visits}</LargeText>
				</LeftContainer>
				<RightContainer>
					{!afterOneYear && (
						<>
							<div>
								{`https://bookfairs.scholastic.com/bf/${homepageData.fairUrl}`}
							</div>
							<div>
								{homepageData.suppressFairFinder
									? "Display on Fair Finder disabled"
									: "Displayed on Fair Finder 21 days before Fair start date"}
							</div>
						</>
					)}
				</RightContainer>
			</Container>
		</CardTemplate>
	);
};

const Container = styled.div`
	display: flex;
	justify-content: left;
	column-gap: 60px;
	@media (max-width: 519px) {
		flex-wrap: wrap;
	}
`;

const LeftContainer = styled.div`
	display: flex;
	gap: 4px;
	width: 143px;
	flex-direction: column;
	justify-content: left;
	margin-bottom: 16px;
	word-wrap: nowrap;
	min-width: 145px;
`;

const RightContainer = styled(LeftContainer)`
	display: flex;
	gap: 15px;
	flex-direction: column;
	justify-content: left;
	word-wrap: wrap;
	width: 100%;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 15px;
`;

const LargeText = styled.div`
	font-weight: 900;
	font-size: 36px;
	line-height: 36px;
`;

const StyledText = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 19px;
`;

export default Homepage;
